import React from "react";
import cx from "classnames";
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";

import * as s from "./PartnerCard.module.sass";

export type IPartner = {
  icon: ImageDataLike;
  label: string;
  link: string;
};

type PartnerCardProps = {
  partner: IPartner;
};

export const PartnerCard: FC<PartnerCardProps> = ({
  partner: { icon, label, link },
  className,
}) => {
  const iconPrepared = getImage(icon)!;

  return (
    <a
      href={link}
      target="_blank"
      rel="nofollow noreferrer"
      className={cx(s.root, className)}
    >
      <span className={s.imageWrapper}>
        <span className={s.imageEffect} />
        <GatsbyImage image={iconPrepared} alt={label} className={s.image} />
      </span>
      {label}
    </a>
  );
};
